// Constants for form data in POST /upload requests

export const WATERMARK_ID = 'watermark_id';
export const WATERMARK_POSITION = 'position';
export const WATERMARK_PROJECT = 'project';
export const WATERMARK_IMAGE_PATH = 'watermarkImagePath';
